export enum InvoiceEditorView {
  Editor = 'editor',
  Preview = 'preview',
}
